<template>
  <div class="spinner"></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

onMounted(() => {
  router.push({ name: 'Agent My Task List' });
});
</script>
